// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/issue-modal/issue-modal.component.css
// module id = 587
// module chunks = 0